module.exports = __webpack_public_path__ + "img/monitor.bdde4716.svg";